module.exports = __webpack_public_path__ + "img/report.daac0c22.png";